import { Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ReactComponent as Ethiquin } from "../../../../assets/images/Ethiquin/alerta_robot.svg";
import { EGIconButton } from "../../../MainComponents/Button/IconButton/IconButton";
import { Stack, Typography } from "@mui/material";
import { EGButton } from "../../../MainComponents/Button/EGButton/EGButton";
import "./Information.scss";

// Content of confirmation modal
const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  title = "",
  description1 = "",
  description2 = "",
  question = "",
}) => {
  const [t] = useTranslation("information");

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      className="confirmationModal"
    >
      <Modal.Body>
        <Row>
          <Col sm={4} className="d-none d-sm-block m-auto">
            <Ethiquin className="px-1 py-2" />
          </Col>
          <Col sm={8} className="p-1">
            <div className="confirmationModal__header mb-3">
              <Typography className="confirmationModal__title" variant="h3">
                <b>{title}</b>
              </Typography>
              <EGIconButton
                iconName="cancel_circle"
                onClick={onHide}
                iconColor="primary"
              />
            </div>

            <div className="confirmationModal__description">
              {description1 && (
                <Typography
                  variant="body1"
                  marginBottom={2}
                  fontSize={"0.9rem"}
                >
                  {description1}
                </Typography>
              )}
              {description2 && (
                <Typography variant="body1" marginBottom={2}>
                  {description2}
                </Typography>
              )}
            </div>

            <div className="confirmationModal__actions">
              <small className="mb-4">{question}</small>
              <Stack
                className="my-2"
                display="flex"
                alignItems="center"
                justifyContent="space-evenly"
                flexDirection="row"
              >
                {onConfirm && (
                  <EGButton
                    label={t("information.confirm")}
                    color="primary"
                    onClick={onConfirm}
                    sx={{ minWidth: "40%", mx: 3 }}
                  />
                )}
                <EGButton
                  label={t("information.cancel")}
                  onClick={onHide}
                  variant="outlined"
                  color="secondary"
                  sx={{ minWidth: "40%", mx: 3 }}
                />
              </Stack>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;
